import React from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

export default function InviteAccept() {
  const navigate = useNavigate();
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      if (!token) { setError('Missing token'); setTimeout(() => navigate('/dashboard'), 1500); return; }
      try {
        const session = (await supabase.auth.getSession()).data.session;
        if (!session) { navigate('/signup'); return; }
        const edgeBase = process.env.REACT_APP_SKINNY_SUPABASE_URL;
        const res = await fetch(`${edgeBase}/functions/v1/team-accept-invite`, {
          method: 'POST',
          headers: { 'content-type': 'application/json', Authorization: `Bearer ${session.access_token}` },
          body: JSON.stringify({ token })
        });
        const ok = res.ok;
        // Regardless of payload, route to dashboard so memberships refresh
        if (!ok) {
          const txt = await res.text();
          setError(txt || 'Accept failed');
          setTimeout(() => navigate('/dashboard'), 1500);
          return;
        }
        navigate('/dashboard');
      } catch (e) {
        setError(String(e?.message || e));
        setTimeout(() => navigate('/dashboard'), 1500);
      }
    })();
  }, [navigate]);

  return (
    <div className="container py-5">
      <h1 className="h4">Accepting Invitation…</h1>
      {error ? <div className="text-danger mt-2 small">{error}</div> : <div className="text-muted mt-2">One moment…</div>}
    </div>
  );
}


